import React, { useEffect, useState, Fragment } from "react";
import Footer from "../Components/Reuseable/Footer.jsx";
import CoptRight from "../Components/Reuseable/Copyrights";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import moment from "moment";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { fetchResultYearFilterForStats } from "../redux/getStatsFilterReduce/getResultYearFilterForStats";
import { fetchRaceTypeFilterForStats } from "../redux/getStatsFilterReduce/getRaceTypeFilterForStats";
import { fetchTrackLengthFilterForStats } from "../redux/getStatsFilterReduce/getTrackLengthFilterForStats";
import { fetchHorseKindFilterForStats } from "../redux/getStatsFilterReduce/getHorseKindFilterForStats";
import { fetchRaceKindFilterForStats } from "../redux/getStatsFilterReduce/getRaceKindFilterForStats";
import Pagination from "./Pagination";
import { fetchRaceNationalityFilterForStats } from "../redux/getStatsFilterReduce/getRaceNationalityFilterForStats";
import { fetchRaceCourseFilterForStats } from "../redux/getStatsFilterReduce/getRaceCourseFilterForStats";
import { fetchDatesFilterForStats } from "../redux/getStatsFilterReduce/getDatesFilterForStats";
import { fetchGroundTypeFilterForStats } from "../redux/getStatsFilterReduce/getGroundTypeFilterForStats";

import { fetchHotForm } from "../redux/getReducer/getHotForm";
import Lottie from "lottie-react";
import Animate from "../assets/loader.json";
import HorseModal from "../Components/Modal/HorseModal";
import { Modal } from "react-bootstrap";
import { DatePicker, Form } from "antd";
import dayjs from "dayjs";

// Isolated Style Import
// import "./HotFormNew.css"; 

const { RangePicker } = DatePicker;

export default function Trainerstatistics() {
  const [form] = Form.useForm();
  const { data: HotForm, status } = useSelector((state) => state.HotForm);
  const { data: ResultYearFilterForStats } = useSelector((state) => state.ResultYearFilterForStats);
  const { data: RaceTypeFilterForStats } = useSelector((state) => state.RaceTypeFilterForStats);
  const { data: TrackLengthFilterForStats } = useSelector((state) => state.TrackLengthFilterForStats);
  const { data: HorseKindFilterForStats } = useSelector((state) => state.HorseKindFilterForStats);
  const { data: RaceKindFilterForStats } = useSelector((state) => state.RaceKindFilterForStats);
  const { data: RaceNationalityFilterForStats } = useSelector((state) => state.RaceNationalityFilterForStats);
  const { data: RaceCourseFilterForStats } = useSelector((state) => state.RaceCourseFilterForStats);
  const { data: GroundTypeFilterForStats } = useSelector((state) => state.GroundTypeFilterForStats);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const cookiedata = Cookies.get("i18next");

  const [ResultYearData, setResultYearData] = useState("");
  const [ResultRaceCourseData, setResultRaceCourse] = useState("");
  const [ResultNationalityData, setResultNationality] = useState("");
  const [ResultRaceTracklengthData, setResultRaceTracklength] = useState("");
  const [ResultHorseKindData, setResultHorseKind] = useState("");
  const [ResultGroundData, setResultGround] = useState("");
  const [ResultRaceTypeData, setResultRaceType] = useState("");
  const [ResultRaceKindData, setResultRaceKind] = useState("");

  const [StartDate, setStartDate] = useState(moment().subtract(179, "days").format("YYYY-MM-DD"));
  const [EndDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));

  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(15);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const [show, setShows] = useState(false);
  const [modaldata, setmodaldatas] = useState();
  const handleClose = () => setShows(false);
  const handleShow = (data) => {
    const id = data?.HorseIDData?._id || data?._id || data;
    if (id) navigate("/horse-detail?" + id);
  };

  const handleDateChange = (dates, dateStrings) => {
    if (!dates || !dateStrings) {
      setStartDate("");
      setEndDate("");
      return;
    }
    setStartDate(dateStrings[0]);
    setEndDate(dateStrings[1]);
  };

  let RaceCourseSearch = ResultRaceCourseData?.id || "";
  let HorseKindSearch = ResultHorseKindData?.id || "";
  let TrackLengthSearch = ResultRaceTracklengthData?.id || "";
  let RaceTypeSearch = ResultRaceTypeData?.id || "";
  let RaceKindSearch = ResultRaceKindData?.id || "";
  let RaceNationalitySearch = ResultNationalityData?.id || "";
  let RaceGroundSearch = ResultGroundData?.id || "";

  // useEffect(() => {
  //   const selectedYear = ResultYearData?.id;
  //   if (!selectedYear) {
  //     setStartDate(moment().subtract(179, "days").format("YYYY-MM-DD"));
  //     setEndDate(moment().format("YYYY-MM-DD"));
  //     return;
  //   }

  //   const startOfYear = moment(`${selectedYear}-01-01`, "YYYY-MM-DD");
  //   const endOfYear = moment(`${selectedYear}-12-31`, "YYYY-MM-DD");
  //   const today = moment();

  //   let start = startOfYear;
  //   let end = endOfYear.isAfter(today, "day") ? today : endOfYear;

  //   // If someone picks a year fully in the future, keep a valid range.
  //   if (end.isBefore(start, "day")) start = end.clone();

  //   setStartDate(start.format("YYYY-MM-DD"));
  //   setEndDate(end.format("YYYY-MM-DD"));
  // }, [ResultYearData]);

  useEffect(() => {
    dispatch(fetchHotForm({ StartDate, EndDate, RaceCourseSearch, HorseKindSearch, TrackLengthSearch, RaceTypeSearch, RaceKindSearch, RaceGroundSearch, RaceNationalitySearch, currentPage }));
  }, [dispatch, StartDate, EndDate, RaceCourseSearch, HorseKindSearch, TrackLengthSearch, RaceTypeSearch, RaceKindSearch, RaceGroundSearch, RaceNationalitySearch, currentPage]);

  useEffect(() => {
    setCurrentPage(1);
  }, [StartDate, EndDate, RaceCourseSearch, HorseKindSearch, TrackLengthSearch, RaceTypeSearch, RaceKindSearch, RaceGroundSearch, RaceNationalitySearch]);

  useEffect(() => {
    let year = ResultYearData?.id;
    let Nationality = ResultNationalityData?.id;
    let RaceCourse = ResultRaceCourseData?.id;
    let GroundType = ResultGroundData?.id;
    let RaceKind = ResultRaceKindData?.id;
    let HorseKind = ResultHorseKindData?.id;
    let RaceType = ResultRaceTypeData?.id;
    let TrackLength = ResultRaceTracklengthData?.id;

    // dispatch(fetchResultYearFilterForStats({ year, Nationality, RaceCourse, GroundType, RaceKind, HorseKind, RaceType, TrackLength }));
    dispatch(fetchRaceTypeFilterForStats({ StartDate, EndDate, Nationality, RaceCourse, GroundType, RaceKind, HorseKind, RaceType, TrackLength }));
    dispatch(fetchTrackLengthFilterForStats({ StartDate, EndDate, Nationality, RaceCourse, GroundType, RaceKind, HorseKind, RaceType, TrackLength }));
    dispatch(fetchHorseKindFilterForStats({ StartDate, EndDate, Nationality, RaceCourse, GroundType, RaceKind, HorseKind, RaceType, TrackLength }));
    dispatch(fetchRaceKindFilterForStats({ StartDate, EndDate, Nationality, RaceCourse, GroundType, RaceKind, HorseKind, RaceType, TrackLength }));
    dispatch(fetchRaceNationalityFilterForStats({ StartDate, EndDate, Nationality, RaceCourse, GroundType, RaceKind, HorseKind, RaceType, TrackLength }));
    dispatch(fetchRaceCourseFilterForStats({ StartDate, EndDate, Nationality, RaceCourse, GroundType, RaceKind, HorseKind, RaceType, TrackLength }));
    dispatch(fetchGroundTypeFilterForStats({ StartDate, EndDate, Nationality, RaceCourse, GroundType, RaceKind, HorseKind, RaceType, TrackLength }));
  }, [dispatch, StartDate, EndDate, ResultYearData, ResultNationalityData, ResultRaceCourseData, ResultGroundData, ResultRaceKindData, ResultHorseKindData, ResultRaceTracklengthData, ResultRaceTypeData]);

  // Logic mappings preserved
  let RaceYearDropdown = ResultYearFilterForStats.map(item => ({ id: item.RacesYear, value: item.RacesYear, label: item.RacesYear }));
  let RaceTypeDropdown = RaceTypeFilterForStats.map(item => ({ id: item._id, value: cookiedata === "en" ? item.NameEn : item.NameAr, label: cookiedata === "en" ? item.NameEn : item.NameAr }));
  let TrackLengthDropdown = TrackLengthFilterForStats.map(item => ({ id: item._id, value: item.TrackLength, label: item.TrackLength }));
  let HorseKindDropdown = HorseKindFilterForStats.map(item => ({ id: item._id, value: cookiedata === "en" ? item.NameEn : item.NameAr, label: cookiedata === "en" ? item.NameEn : item.NameAr }));
  let RaceKindDropdown = RaceKindFilterForStats.map(item => ({ id: item._id, value: cookiedata === "en" ? item.NameEn : item.NameAr, label: cookiedata === "en" ? item.NameEn : item.NameAr }));
  let NationalityDropdown = RaceNationalityFilterForStats.map(item => ({ id: item?.NationalityDataRaceCourse?._id, value: cookiedata === "en" ? item?.NationalityDataRaceCourse?.NameEn : item?.NationalityDataRaceCourse?.NameAr, label: cookiedata === "en" ? item.NationalityDataRaceCourse?.NameEn : item?.NationalityDataRaceCourse?.NameAr }));
  let RaceCourseDropdown = RaceCourseFilterForStats.map(item => ({ id: item._id, value: cookiedata === "en" ? item.TrackNameEn : item.TrackNameAr, label: cookiedata === "en" ? item.TrackNameEn : item.TrackNameAr }));
  let GroundTypeDropdown = GroundTypeFilterForStats?.map(item => ({ id: item._id, value: cookiedata === "en" ? item.NameEn : item.NameAr, label: cookiedata === "en" ? item.NameEn : item.NameAr }));

  function toPascalCase(str) { return str ? str.split(/\s+/).map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()).join(" ") : ""; }

  const customSelectStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: '#0c1a3e',
      border: 'none',
      borderRadius: '8px',
      minHeight: '44px',
      color: 'white',
      marginBottom: '0',
      cursor: 'pointer',
      boxShadow: 'none'
    }),
    singleValue: (provided) => ({
      ...provided,
      color: 'white'
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#9da7be',
      fontSize: '13px'
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: 'white'
    }),
    indicatorSeparator: () => ({
      display: 'none'
    }),
    clearIndicator: (provided) => ({
      ...provided,
      color: '#fff',
      padding: '0 8px'
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: '2px 8px',
      overflow: 'hidden'
    }),
    input: (provided) => ({
      ...provided,
      margin: 0,
      padding: 0,
      opacity: 0
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: '#0c1a3e',
      zIndex: 9999
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? '#2173d1' : '#0c1a3e',
      color: 'white',
      fontSize: '13px',
      cursor: 'pointer'
    })
  };


  return (
    <Form layout="vertical" form={form}>
      <Fragment>
        <div className="new-hotform-page-wrapper">
          <div className="common-page-banner">
            <h1>{t("Hot Form")}</h1>
          </div>

          <div className="new-main-card-container">
            <div className="new-filter-card">
              <div className="new-dropdown-flex-row">
                <div className="new-range-item">
                  <style>{`.new-hotform-page-wrapper .new-custom-range-picker input::placeholder { color: #9da7be !important; -webkit-text-fill-color: #9da7be !important; opacity: 1 !important; }`}</style>
                  <RangePicker
                    value={[
                      StartDate ? dayjs(StartDate, "YYYY-MM-DD") : null,
                      EndDate ? dayjs(EndDate, "YYYY-MM-DD") : null,
                    ]}
                    onChange={handleDateChange}
                    format="YYYY-MM-DD"
                    className="new-custom-range-picker"
                    placeholder={[t("Start Date"), t("End Date")]}
                    separator={<span style={{ color: '#9da7be' }}>To</span>}
                    allowClear
                  />
                </div>
                <Select styles={customSelectStyles} placeholder={t("Nationality")} options={NationalityDropdown} onChange={setResultNationality} className="new-flex-item" isClearable />
                <Select styles={customSelectStyles} placeholder={t("Race course")} options={RaceCourseDropdown} onChange={setResultRaceCourse} className="new-flex-item" isClearable />
                <Select styles={customSelectStyles} placeholder={t("Ground Type")} options={GroundTypeDropdown} onChange={setResultGround} className="new-flex-item" isClearable />
              </div>

              <div className="new-search-date-row">
                <Select styles={customSelectStyles} placeholder={t("Race Kind")} options={RaceKindDropdown} onChange={setResultRaceKind} className="new-flex-item" isClearable />
                <Select styles={customSelectStyles} placeholder={t("Kind Of Horse")} options={HorseKindDropdown} onChange={setResultHorseKind} className="new-flex-item" isClearable />
                <Select styles={customSelectStyles} placeholder={t("Track length")} options={TrackLengthDropdown} onChange={setResultRaceTracklength} className="new-flex-item" isClearable />
                <Select styles={customSelectStyles} placeholder={t("Race type")} options={RaceTypeDropdown} onChange={setResultRaceType} className="new-flex-item" isClearable />
              </div>
            </div>

            <div className="new-stats-table-box">
              {status === "idle" ? (
                <div className="new-grid-table">
                  <div className="new-grid-thead">
                    <div className="new-th">{t("Horse Name")}</div>
                    <div className="new-th">{t("Runs")}</div>
                    <div className="new-th">{t("Wins")}</div>
                    <div className="new-th">{t("Place")}</div>
                    <div className="new-th">{t("Wins")}%</div>
                    <div className="new-th">{t("Place")}%</div>
                    <div className="new-th">{t("Earning")}</div>
                    <div className="new-th">{t("Turf Earning")}</div>
                    <div className="new-th">{t("Dirt Earning")}</div>
                  </div>

                  <div className="new-grid-tbody">
                    {HotForm?.data && HotForm.data.map((item, i) => (
                      item.HorseIDData?.placespercentage > 60 && (
                        <div key={i} className="new-grid-row-card">
                          <div className="new-td new-clickable-horse" onClick={() => handleShow(item)}>
                            {item.HorseIDData ? (cookiedata === "en" ? toPascalCase(item.HorseIDData.NameEn) : item.HorseIDData.NameAr) : "-"}
                          </div>
                          <div className="new-td">{item.HorseIDData?.Runs || 0}</div>
                          <div className="new-td">{item.HorseIDData?.wins || 0}</div>
                          <div className="new-td">{item.HorseIDData?.places || 0}</div>
                          <div className="new-td">{Number(item.HorseIDData?.winspercentage || 0).toFixed(2)}</div>
                          <div className="new-td">{Number(item.HorseIDData?.placespercentage || 0).toFixed(2)}</div>
                          <div className="new-td">{t("AED")} {Number(item.HorseIDData?.Earnings || 0).toLocaleString()}</div>
                          <div className="new-td">{t("AED")} {Number(item.HorseIDData?.TurfEarnings || 0).toLocaleString()}</div>
                          <div className="new-td">{t("AED")} {Number(item.HorseIDData?.DirtEarnings || 0).toLocaleString()}</div>
                        </div>
                      )
                    ))}
                  </div>
                </div>
              ) : (
                <div className="new-loader-box"><Lottie animationData={Animate} style={{ width: '100px', margin: 'auto' }} /></div>
              )}
            </div>
            <div className="new-pagination-wrapper">
              <Pagination
                postsPerPage={postsPerPage}
                totalPosts={HotForm?.totalcount}
                paginate={paginate}
                currentPage={currentPage}
              />
            </div>
          </div>



          <Footer />
          <CoptRight />
        </div>
      </Fragment>
    </Form>
  );
}